import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import styled from 'styled-components';
import { AnimationHeartWrapper, FirstLogoWrapperWithHeart, SecondLogoWrapper } from '../AnimateLogoPair';
import { BrandAnimationLayout } from '../styles';

export const RevolutAnimationLayout = styled(BrandAnimationLayout)`
  ${FirstLogoWrapperWithHeart} {
    margin: 0 auto;
    ${MEDIA_QUERIES.desktop`
      height: 30px;
    `}
    ${MEDIA_QUERIES.upToDesktop`
      height: 21px;
    `}
  }

  ${SecondLogoWrapper} {
    ${MEDIA_QUERIES.desktop`
      height: 32px;
    `}
    ${MEDIA_QUERIES.upToDesktop`
      height: 25px;
    `}
  }

  ${AnimationHeartWrapper} {
    ${MEDIA_QUERIES.desktop`
      margin-top: 29px;
      margin-bottom: 18px;
    `}
    ${MEDIA_QUERIES.upToDesktop`
      margin: 12px 0;
    `}
  }
  }
`;
